<template>
  <div class="container info">
    <div class="offset-center border">
      <h3>{{ this.totalVideos }} videos so far :)</h3>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Info",
  data() {
    return {
      totalVideos: 0,
      src:
        "https://www.googleapis.com/youtube/v3/search?part=snippet&type=video&channelId=UCltyfUM94CjhCEMDJah1mag&maxResults=0&order=date&key=AIzaSyCKpteVE5B7iYcMZ-eOs8v8yfruUWRNXYg"
    };
  },
  created() {
    axios.get(this.src).then(response => {
      this.totalVideos = response.data.pageInfo.totalResults;
    });
  }
};
</script>

<style>
.info {
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  margin-top: 3px;
  margin-bottom: 5px;
}

.offset-center {
  grid-column: 3/4;
}

.border {
  border-style: solid;
}

@media (max-width: 800px) {
  .info {
    grid-template-columns: auto auto auto;
    margin-top: 3px;
    margin-bottom: 5px;
  }

  .offset-center {
    grid-column: 2/3;
  }
}
</style>
